<template>
  <button
      class="button"
      :disabled="isDisabled"
      :class="[{active: isLoading}]"
  >
    <ui-loader class="button__loader" v-if="isLoading" />
    <slot v-else />
  </button>
</template>

<script setup>
import UiLoader from "@/components/ui/ui-loader.vue";

const props = defineProps({
  isDisabled: Boolean,
  isLoading: Boolean
})
</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
  width: 100%;
  padding-block: 10px;
  border-radius: 4px;
  background-color: #5B194F;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  display: grid;
  place-items: center;
  transition: 0.2s;

  color: $white;
  text-align: center;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    background-color: #7c276d;
  }
  
  &:disabled {
    cursor: not-allowed;
    background-color: #5B194F;

    &:hover {
      background-color: #5B194F;
    }
  }

  &__loader {
    margin-block: 7px;
  }
}

@media (max-width: 450px) {
  .button {

  }
}
</style>